
















































import * as Cons from './router/constant'

export default {
  name: 'App',
  data() {
    return {
      Cons,
      selectedMenu: 'canvas'
    }
  },
  watch: {
    $route() {
      this.updateSelectedMenu()
    }
  },
  created() {
    this.updateSelectedMenu()
  },
  methods: {
    to(routePath){
      this.$router.push(routePath);
    },
    backtoMenu() {
      this.$router.push('main')
    },
    updateSelectedMenu() {
      if (this.$route.path === `/${Cons.CANVAS_TREE}`) {
        this.selectedMenu = 'canvas'
      } else {
        this.selectedMenu = 'svg'
      }
    }
  }
}
